import { Injectable } from "@angular/core";

@Injectable()
export class VersionCheckService {

    localVersion() {
        // @ts-ignore
        return env.version;
    }
}
